import { WalkthroughDialog } from '../common/WalkthroughDialog';
import {
  CATALOG_WALKTHROUGH_TITLE,
  CATALOG_WALKTHROUGH_STORAGE_KEY,
  catalogWalkthroughPages,
} from '../../content/catalogWalkthrough';

export const CatalogWalkThrough = () => {
  return (
    <WalkthroughDialog
        dialogTitle={CATALOG_WALKTHROUGH_TITLE}
        storageKey={CATALOG_WALKTHROUGH_STORAGE_KEY}
        pages={catalogWalkthroughPages}
        triggerPath="/catalog"
    />
  );
}